<template>
  <div
    style="
      width: 100%;
      height: 100%;
      background-color: #fff;
      box-sizing: border-box;
      padding: 10px;
      padding-top: 0;
      overflow: hidden;
    "
  >
    <div
      style="
        height: 40px;
        display: flex;
        font-size: 18px;
        font-weight: bold;
        align-items: center;
      "
    >
      <div style="margin-right: 10px">
        <el-button type="primary" @click="$router.go(-1)"
          ><i class="el-icon-back" style="margin-right: 10px"></i>
          后退前页</el-button
        >
      </div>
      <div style="color: #000">
        <span
          style="cursor: pointer"
          @click="$router.push('/ProjectInfo/ProjectAll?id=' + $route.query.id)"
          >{{ backName || '工作台' }}</span
        >
        <i class="el-icon-arrow-right"></i>
      </div>
      <div style="color: #606266" class="ellipsis">邀请供应商</div>
    </div>
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      size="mini"
      style="margin-top: 10px"
    >
      <el-tab-pane label="供应商信息" name="Team"> </el-tab-pane>
      <el-tab-pane label="分包商信息" name="TeamChild"> </el-tab-pane>
    </el-tabs>
    <Team
      ref="team"
      :pId="pId"
      v-if="activeName === 'Team'"
      style="width: 100%; height: calc(100% - 90px)"
    ></Team>
    <TeamChild
      ref="TeamChild"
      :pId="pId"
      v-if="activeName === 'TeamChild'"
      style="width: 100%; height: calc(100% - 90px)"
    ></TeamChild>
    <!-- <TempMaintain
      ref="TempMaintain"
      :pId="pId"
      v-if="activeName === 'TempMaintain'"
    ></TempMaintain>
    <TempManufacturers
      ref="TempManufacturers"
      :pId="pId"
      v-if="activeName === 'TempManufacturers'"
    ></TempManufacturers> -->
  </div>
</template>
<script>
import Team from './Team.vue' // 供应商信息
import TeamChild from './TeamChild.vue' // 供应商信息
// import TempMaintain from './TempMaintain.vue' // 设备维修商信息
// import TempManufacturers from './TempManufacturers.vue' // 设备厂家信息

export default {
  props: {},
  data() {
    return {
      backName: '',
      activeName: 'Team',
      pId: '',
    }
  },

  components: {
    Team,
    TeamChild,
    //TempMaintain,
    // TempManufacturers
  },
  methods: {
    handleClick() {},
  },
  mounted() {},
  created() {
    this.pId = this.$route.query.id
    this.backName = window.localStorage.getItem('ProjectName') || ''
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-tabs__header {
  margin-bottom: 0;
}
</style>
